import { applyMiddleware, combineReducers, legacy_createStore } from "redux"
import { authReducer } from "./Auth/Redux"
import { thunk } from "redux-thunk"
import { taskReducer } from "./Task/Redux"
import { dailyUpdateReducer } from "./DailyUpdate/Redux"
import { dailyUpdateApprovalReducer } from "./DailyUpdateApproval/Redux"
import { newHireReducer } from "./NewHire/Redux"
import { timeSheetReducer } from "./TimeSheet/Redux"
import { socialPostReducer } from "./SocialPost/Redux"
import { leaveReducer } from "./Leave/Redux"
import { configReducer } from "./Config/Redux"
import { alertReducer } from "./Alert/Redux"

const rootReducer=combineReducers({

    auth:authReducer,
    task:taskReducer,
    dailyUpdate:dailyUpdateReducer,
    dailyUpdateApprover:dailyUpdateApprovalReducer,
    newHireData:newHireReducer,
    timeSheet:timeSheetReducer,
    social:socialPostReducer,
    leave:leaveReducer,
    config:configReducer,
    alert:alertReducer,
})
export const store=legacy_createStore(rootReducer,applyMiddleware(thunk))